import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication.service';
import { PublicationService } from '../../services/publication.service';
import { TranslateService } from '@ngx-translate/core';
import { OverlayService } from '../../services/overlay.service';
import { SsoConfig } from './login-user-sso.component';

@Component({
	selector: 'login-user',
	templateUrl: './login-user.component.html',
	styleUrls: ['./login-user.component.scss']
})

export class LoginUserComponent implements OnInit, OnDestroy {
	public busy: boolean;
	public capslockOn: boolean;
	public passwordErrorOccured: boolean;

	public username: string;
	public password: string;
	public ssoProviders: SsoConfig[];

	public ready = false;

	private subscriptions = new Subscription();

	@Input('tagLine') tagLine = '';

	constructor(
		private authenticationService: AuthenticationService,
		private publicationService: PublicationService,
		private translate: TranslateService,
		private overlayService: OverlayService
	) { }

	@HostListener('window:focus', ['$event'])
	onFocus(event: KeyboardEvent): void {
		this.checkCapsLockState(event);
	}

	@HostListener('window:keydown', ['$event'])
	onKeyDown(event: KeyboardEvent): void {
		this.checkCapsLockState(event);
		this.passwordErrorOccured = false;
	}

	@HostListener('window:keyup', ['$event'])
	onKeyUp(event: KeyboardEvent): void {
		this.checkCapsLockState(event);
		this.passwordErrorOccured = false;
	}

	ngOnInit() {
		this.subscriptions.add(this.publicationService.getConfig().subscribe((config: any) => {
			if (config && config.ssoProviders) {
				this.ssoProviders = Array.isArray(config.ssoProviders) ? config.ssoProviders : [config.ssoProviders];
				this.checkSsoCookie();
			}
			this.ready = true; // will prevent content shuffle when sso needs to be added
		}));
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	login() {
		this.busy = true;
		this.authenticationService.login(this.username, this.password)
			.pipe(
				catchError((error: any) => {
					this.busy = false;
					this.passwordErrorOccured = true;
					return of(error);
				})
			).subscribe(() => {
				this.busy = false;
				this.authenticationService.checkForPublication();
			});
	}

	private checkCapsLockState(event: KeyboardEvent) {
		this.capslockOn = event.getModifierState && event.getModifierState('CapsLock');
	}

	private checkSsoCookie() {
		const ssoErrorCookie: string = (document.cookie.match(/^(?:.*;)?\s*sso_error\s*=\s*([^;]+)(?:.*)?$/) || [])[1];
		if (ssoErrorCookie) {
			const value = JSON.parse(decodeURIComponent(ssoErrorCookie));
			this.overlayService.createToast(this.translate.instant('ERROR_SSO_LOGIN', { errorCode: value.code, errorMessage: value.message }));
		}
	}
}
